export enum Form {
	REQUIRED = 'Required field',
	INVALID_SELECTION = 'Invalid selection',
	BACK_BUTTON_LABEL = 'Back',
	CANCEL_BUTTON_LABEL = 'Cancel',
	SUBMIT_BUTTON_LABEL = 'Submit',
	CLOSE_BUTTON_LABEL = 'Close'
}
